module.exports = {
      id: "update-black-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#update-black",
      toString: function () {
        return this.url;
      }
    }